<template>
  <LoadingWrapper :state="status">
    <div class="mt-4 flex flex-col" v-if="data.analysis.individualValues.length">
      <JournalAnalysis
        :individual-values="data.analysis.individualValues"
        :surveys="data.analysis.surveys"
        :scale="data.analysis.scale"
        :questions="data.analysis.questions"
        :display-in-profile="true"
        :selectable="true"
      />
    </div>
    <EmptyPage
      v-else
      :title="data.feedbackTopic.title"
      :description="$t('profile.emptyTopicDescription')"
      :icon="data.feedbackTopic.icon!"
    />
  </LoadingWrapper>
</template>
<script setup lang="ts">
  import LoadingWrapper from '@/core/components/loading/LoadingWrapper.vue'
  import EmptyPage from '@/core/components/empty-states/EmptyPage.vue'
  import JournalAnalysis from '@/core/components/journal-analysis/JournalAnalysis.vue'
  import { useCoacheeJournalProfile } from '../composables/use-coachee-journal-profile'
  import { toRef } from 'vue'

  interface Props {
    feedbackTopicId: string
  }

  const props = defineProps<Props>()

  const { data, status } = useCoacheeJournalProfile(toRef(props, 'feedbackTopicId'))
</script>
